import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import Numeral from 'numeral';
import Slider from "react-slick";
import {startFetchJobDetails} from '../actions/jobAds'
import Loading from '../components/Loading';
import {enToFa} from '../utils/NumberUtility'
import logo from '../assets/images/C_logo.png';
import {
    startAddJobToFavourites,
    startRemoveJobFromFavourites,
    startReportJobAd
} from '../actions/jobAds';
import ModalComponent from '../components/ModalComponent';

const JobDetails = (props) => {

    const [isLoading, setLoading] = useState(true);
    const [isFavoured, setFavoured] = useState(false);
    const [reportDialog, setReportDialog] = useState(false);

    const detailKeys = [
        { key: "jobType", translation: 'عنوان شغل' },
        { key: "city", translation: 'شهر' },
        { key: "address", translation: 'آدرس' },
        { key: "phoneNo", translation: 'شماره ثابت' },
        { key: "mobileNo", translation: 'شماره همراه' },
        { key: "faxNo", translation: 'شماره فکس' },
        { key: "website", translation: 'آدرس سایت' },
        { key: "instagramLink", translation: 'آدرس اینستاگرام' },
        { key: "email", translation: 'آدرس ایمیل' },
    ]

    useEffect(() => {
        if (isLoading){
            props.startFetchJobDetails(props.match.params.id)
            .then(({success, error}) => {
                if (success){
                    setLoading(false)
                }
                else{
                    setLoading(false)
                }
            })
        }
    }, [isLoading])
    
    useEffect(() => {

        if (props.favourites && props.details) {
            setFavoured(props.favourites.includes(props.details.id))
        }
    }, [props.favourites, props.details])

    const settings = {
        arrows: false,
        dots: true,
        infinite: true,
        rtl: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const onFavouriteClicked = (e) => {
        if (isFavoured) {
            props.startRemoveJobFromFavourites(props.details.id)
        } else {
            props.startAddJobToFavourites(props.details.id)
        }
    }

    const onReportClicked = (e) => {
        props.startReportJobAd(props.details.id)
        .then(({success, error}) => {
                if (success){
                    setReportDialog(true)
                }
                else{
                }
            })
    }

    const handleCloseReportModal = (e) => {
        setReportDialog(false);
    }

    const renderSlides = () => {
        const slides = props.details.images.length == 0 ? [logo] : props.details.images.map((item) => (item.image))
        // const slides = [logo, logo, logo];
        return slides.map((slide) => {
            return (
                <div className={props.details.images.length == 0 ? "carousel__slide--no-img" : "carousel__slide"}>
                    <img className={ props.details.images.length == 0 ? "carousel__slide-image--no-img" : "carousel__slide-image"} src={slide}/>
                </div>
            );
        });
    }

    return (
        <div className="container-sm optimized__d-flex-class flex-column h-100 px-0 vehicle-details">
        {
            isLoading ? (
                <Loading/>
            ) : (
                <div className="vehicle-details__main-scroll px-0">
                    <Slider {...settings}>
                        {renderSlides()}
                    </Slider>
                    <div className="optimized__d-flex-class flex-column flex-grow-1 pt-3">
                        <div className="optimized__d-flex-class flex-row align-items-center justify-content-between">
                            <span className="vehicle-details__title px-4">{props.details.title}</span>
                            <div className="optimized__d-flex-class flex-row align-items-center px-4">
                                <span onClick={onReportClicked}><i class="material-icons m-2">warning</i></span>
                                <span onClick={onFavouriteClicked}><i class={`material-icons m-2 ${isFavoured ? "vehicle-details__icon--active" : ""}`}>star</i></span>
                            </div>
                            <ModalComponent
                                onRequestClose={handleCloseReportModal}
                                isOpen={reportDialog}>
                                <div className="dashboard__info-modal d-flex flex-column flex-grow-1">
                                    <span>گزارش شما با موفقیت ثبت شد</span>
                                    <div className="optimized__d-flex-class justify-content-end pt-3">
                                        <button className="btn__close m-0" onClick={handleCloseReportModal}>بستن</button>
                                    </div>
                                </div>
                            </ModalComponent>
                        </div>
                        <div className="optimized__d-flex-class flex-row px-4 justify-content-between align-items-center">
                            <span className="vehicle-details__sub-title">{props.details.jobType.title}</span>
                        </div>
                        <hr className="vehicle-details__separator mx-3"/>
                        <div className="optimized__d-flex-class justify-content-between align-items-center px-4">
                            <a className="vehicle-details__contact-button ml-3" href={`https://api.whatsapp.com/send?text=http://m.carclick.ir/job/${props.details.id} - ${props.details['title']}`}>اشتراک در واتس‌اپ</a>
                            <a className="vehicle-details__contact-button mr-3" href={`https://telegram.me/share/url?url=http://m.carclick.ir/job/${props.details.id}&text=${props.details['title']}`}>اشتراک در تلگرام</a>
                        </div>
                        <div className="optimized__d-flex-class justify-content-between align-items-center px-4">
                            <a className="vehicle-details__contact-button mt-3" href={`tel:${props.details.verifiedPhoneNumber}`}>تماس تلفنی</a>
                        </div>
                        <div className="vehicle-details__sub-bg mt-3 pb-4">
                            <span className="vehicle-details__table-title py-1">جزئیات</span>
                            <div className="vehicle-details__table-container mx-4">
                                {detailKeys.map((currentKey) => {
                                    return props.details[currentKey['key']] ? (
                                        <>
                                            <span className="vehicle-details__table-key col-6">{currentKey['translation']}: </span>
                                            {
                                                (props.details[currentKey['key']]['name'] || props.details[currentKey['key']]['title']) ? (
                                                    <span className="vehicle-details__table-value col-6">{props.details[currentKey['key']]['name'] || props.details[currentKey['key']]['title']}</span>
                                                ) : (
                                                    <span className="vehicle-details__table-value col-6">{enToFa(props.details[currentKey['key']])}</span>
                                                )
                                            }
                                        </>
                                    ) : undefined
                                })}
                                <span className="vehicle-details__table-key col-12 mt-3">توضیحات فروشنده:</span>
                                <span className="vehicle-details__table-value col-12 text-justify">{enToFa(props.details['description'] || "بدون توضیحات")}</span>
                                <div className="vehicle-details__warning p-2 mt-3 text-justify">
                                    بدیهی است که کارکلیک هیچگونه مسئولیتی در قبال معامله و نوع پرداخت طرفین ندارد، لذا قبل از انجام معامله، از صحت و سلامت کالا اطمینان حاصل کنید.
                                </div>
                            </div>
                            <span className="vehicle-details__title px-4 d-none">آگهی‌های مشابه</span>
                        </div>
                    </div>
                </div>
            )
        }
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    startFetchJobDetails: (id) => dispatch(startFetchJobDetails(id)),
    startAddJobToFavourites: (id) => dispatch(startAddJobToFavourites(id)),
    startRemoveJobFromFavourites: (id) => dispatch(startRemoveJobFromFavourites(id)),
    startReportJobAd: (id) => dispatch(startReportJobAd(id)),

})

const mapStateToProps = (state, props) => ({
    details: state.jobAds.detail,
    favourites: state.jobConfigs.favouriteJobAds
})

export default connect(mapStateToProps, mapDispatchToProps)(JobDetails);